export function loadRingCentralSDK() {
  return new Promise((resolve, reject) => {
    if (window.RingCentral && window.RingCentral.EmbeddableVoiceAdapter) {
      resolve(window.RingCentral);
      return;
    }
    const script = document.createElement('script');
    script.src = `https://apps.ringcentral.com/integration/ringcentral-embeddable/2.2.0/adapter.js?clientId=${process.env.VUE_APP_RC_CLIENT_ID}`;
    script.async = true;
    script.onload = () => resolve(window.RingCentral);
    script.onerror = () => reject(new Error('Failed to load RingCentral SDK'));

    document.head.appendChild(script);
  });
}
